<template>
  <section class="section">
    <div class="container columns">
      <b-field label="From" class="column" expanded>
        <b-datetimepicker placeholder="Click to select..." icon="calendar" :datepicker="{ showWeekNumber }" :timepicker="{ enableSeconds }" v-model="fromDate"></b-datetimepicker>
      </b-field>
      <b-field label="To" class="column" expanded>
        <b-datetimepicker placeholder="Click to select..." icon="calendar" :datepicker="{ showWeekNumber }" :timepicker="{ enableSeconds }" v-model="toDate"></b-datetimepicker>
      </b-field>
      <b-field label="Customer" class="column">
        <b-dropdown v-model="selectedCompany" hoverable aria-role="list">
          <button class="button is-info" slot="trigger">
            <span>{{ selectedCompany.CustomerName }}</span>
            <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item v-for="customer in customers" :key="customer.CustomerID" aria-role="listitem" :value="customer">{{ customer.CustomerName }}</b-dropdown-item>
        </b-dropdown>
      </b-field>
    </div>
    <div class="container">
      <section>
        <b-button v-on:click="filterAdded" class="button is-primary">Submit</b-button>
      </section>
    </div>
    <div class="container" v-if="initialSubmit">
      <div class="columns">
        <div class="column">
          <h1 class="title">Results Returned From Providers</h1>
          <bar-chart :chart-data="overallChartData" :styles="myStyles" />
        </div>
        <div class="column">
          <h1 class="title">Amount of Addresses Offered</h1>
          <bar-chart :chart-data="returnChartData" :styles="myStyles" />
        </div>
      </div>
    </div>
    <div class="container" v-if="initialSubmit">
      <b-select v-model="perPage" @input="perPageChanged">
        <option value="1">1 per page</option>
        <option value="5">5 per page</option>
        <option value="10">10 per page</option>
        <option value="25">25 per page</option>
        <option value="50">50 per page</option>
      </b-select>
      <b-table
        :total="total"
        :data="requests"
        ref="table"
        detailed
        hoverable
        :default-sort="['Added', 'asc']"
        detail-key="ID"
        paginated
        backend-pagination
        backend-sorting
        backend-filtering
        :per-page="perPage"
        @page-change="onPageChange"
        @sort="onSort"
        @details-open="detailsOpened"
      >
        <b-table-column field="Query" label="Query" sortable v-slot="props">{{ props.row.Query }}</b-table-column>

        <b-table-column field="ReturnedAddresses" label="ReturnedAddresses" sortable v-slot="props">{{ props.row.ReturnedAddresses }}</b-table-column>

        <b-table-column field="HasBeenSelected" label="Selected" sortable centered v-slot="props">{{ props.row.HasBeenSelected }}</b-table-column>

        <b-table-column field="CustomerName" label="CustomerName" sortable v-slot="props">{{ props.row.CustomerName }}</b-table-column>

        <b-table-column field="IsPickup" label="IsPickup" sortable centered v-slot="props">{{ props.row.IsPickup }}</b-table-column>

        <b-table-column field="Added" label="Added" sortable centered v-slot="props">{{ props.row.Added }}</b-table-column>

        <template slot="detail" slot-scope="detailProps">
          <b-loading :is-full-page="false" :active.sync="isDetailLoading" :can-cancel="false"></b-loading>
          <template v-if="detailProps.row.detail">
            <section>
              <b-tabs position="is-centered" class="block">
                <b-tab-item label="Details">
                  <b-table :data="detailProps.row.detailArray">
                    <b-table-column field="name" label="Name" v-slot="props">
                      <template v-if="props.row.name != 'ProviderRequests' && props.row.name != 'OfferedAddresses'">
                        {{ props.row.name }}
                      </template>
                    </b-table-column>

                    <b-table-column field="value" label="Value" v-slot="props">
                      <template v-if="props.row.name != 'ProviderRequests' && props.row.name != 'OfferedAddresses' && props.row.name != 'Provider'">
                        {{ props.row.value }}
                      </template>
                      <template v-if="props.row.name == 'Provider'">
                        {{ props.row.value.ProviderName }}
                      </template>
                    </b-table-column>
                  </b-table>
                </b-tab-item>
                <b-tab-item label="Provider Requests">
                  <b-table :data="detailProps.row.detail.ProviderRequests" detailed default-sort="Added">
                    <b-table-column field="provider" label="Provider" v-slot="props">
                      <template v-if="props.row.name != 'ProviderRequests' && props.row.name != 'OfferedAddresses'">
                        {{ props.row.Provider.ProviderName }}
                      </template>
                    </b-table-column>
                    <b-table-column field="providertype" label="ProviderType" v-slot="props">
                      <template v-if="props.row.name != 'ProviderRequests' && props.row.name != 'OfferedAddresses'">
                        {{ props.row.ProviderType.ProviderType }}
                      </template>
                    </b-table-column>
                    <b-table-column field="query" label="Query" v-slot="props">
                      <template v-if="props.row.name != 'ProviderRequests' && props.row.name != 'OfferedAddresses'">
                        {{ props.row.Query.Query }}
                      </template>
                    </b-table-column>
                    <b-table-column field="returned" label="Returned" v-slot="props">
                      <template v-if="props.row.name != 'ProviderRequests' && props.row.name != 'OfferedAddresses'">
                        {{ props.row.ReturnedAddresses.length }}
                      </template>
                    </b-table-column>
                    <b-table-column field="added" label="Added" v-slot="props">
                      <template v-if="props.row.name != 'ProviderRequests' && props.row.name != 'OfferedAddresses'">
                        {{ props.row.Added }}
                      </template>
                    </b-table-column>
                    <template slot="detail" slot-scope="providerRequestProps">
                      <b-table :data="providerRequestProps.row.ReturnedAddresses">
                        <b-table-column field="addressid" label="AddressID" v-slot="props">
                          {{ props.row.AddressID }}
                        </b-table-column>
                        <b-table-column field="address" label="Address" v-slot="props">
                          {{ props.row.Address }}
                        </b-table-column>
                        <b-table-column field="lat" label="Lat" v-slot="props">
                          {{ props.row.Lat }}
                        </b-table-column>
                        <b-table-column field="long" label="Long" v-slot="props">
                          {{ props.row.Long }}
                        </b-table-column>
                        <b-table-column field="addedby" label="ProviderAddedBy" v-slot="props">
                          {{ props.row.ProviderAddedBy.ProviderName }}
                        </b-table-column>
                        <b-table-column field="typeaddedby" label="ProviderTypeAddedBy" v-slot="props">
                          {{ props.row.ProviderTypeAddedBy.ProviderType }}
                        </b-table-column>
                      </b-table>
                    </template>
                  </b-table>
                </b-tab-item>
                <b-tab-item label="Offered Addresses">
                  <b-table :data="detailProps.row.detail.OfferedAddresses">
                    <b-table-column field="addressid" label="AddressID" v-slot="props">
                      {{ props.row.AddressID }}
                    </b-table-column>
                    <b-table-column field="address" label="Address" v-slot="props">
                      {{ props.row.Address }}
                    </b-table-column>
                    <b-table-column field="lat" label="Lat" v-slot="props">
                      {{ props.row.Lat }}
                    </b-table-column>
                    <b-table-column field="long" label="Long" v-slot="props">
                      {{ props.row.Long }}
                    </b-table-column>
                    <b-table-column field="selected" label="Selected" v-slot="props">
                      {{ props.row.Selected }}
                    </b-table-column>
                    <b-table-column field="providerused" label="ProviderUsed" v-slot="props">
                      {{ props.row.ProviderUsed.ProviderName }}
                    </b-table-column>
                    <b-table-column field="providertypeused" label="ProviderTypeUsed" v-slot="props">
                      {{ props.row.ProviderTypeUsed.ProviderType }}
                    </b-table-column>
                    <b-table-column field="addedby" label="ProviderAddedBy" v-slot="props">
                      {{ props.row.ProviderAddedBy.ProviderName }}
                    </b-table-column>
                    <b-table-column field="typeaddedby" label="ProviderTypeAddedBy" v-slot="props">
                      {{ props.row.ProviderTypeAddedBy.ProviderType }}
                    </b-table-column>
                  </b-table>
                </b-tab-item>
              </b-tabs>
            </section>
          </template>
        </template>
      </b-table>
    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true"></b-loading>
  </section>
</template>

<script>
import axios from "axios";
const GlobalConfig = require("../../config/index");
var dateFormat = require("dateformat");
import BarChart from "@/sections/lookupengine/components/Charts/BarChart.vue";

export default {
  name: "ProviderRequests",
  components: { BarChart },
  data: function () {
    return {
      initialSubmit: false,
      fromDate: new Date(new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() + " 00:00:00"),
      toDate: new Date(new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() + " 23:59:59"),
      fromDateDetail: new Date(new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() + " 00:00:00"),
      toDateDetail: new Date(new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() + " 23:59:59"),
      customers: [],
      showWeekNumber: false,
      filteringDate: false,
      enableSeconds: true,
      selectedCompany: { CustomerID: -1, CustomerName: "All Customers" },
      selectedProvider: -1,
      selectedProviderType: -1,
      isLoading: false,
      overallChartData: {
        labels: [],
        datasets: [],
      },
      chartColor: this.getColor(),
      returnChartData: {
        labels: [],
        datasets: [],
      },
      isDetailLoading: false,
      perPage: 25,
      total: -1,
      page: 1,
      sortField: "",
      sortOrder: "",
    };
  },
  beforeMount() {
    this.GetCompanies();
  },
  computed: {
    myStyles() {
      return {
        height: `600px`,
        position: "relative",
      };
    },
  },
  methods: {
    filterAdded: async function () {
      this.filteringDate = true;
      this.isLoading = true;
      await this.LoadRequests();
      await this.LoadReturnedAddressesChart();
      await this.LoadProviderReturnsChart();
      this.isLoading = false;
      this.initialSubmit = true;
    },
    LoadRequests: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const requests = await axios.get(
        `${GlobalConfig.default.GetAPIURL()}/api/stats/requests?customerId=${this.selectedCompany.CustomerID}&dateFrom=${dateFormat(this.fromDate, "isoDateTime").split("+")[0]}Z` +
          `&dateTo=${dateFormat(this.toDate, "isoDateTime").split("+")[0]}Z` +
          `&sort=${this.sortField}` +
          `&sortOrder=${this.sortOrder}` +
          `&page=${this.page}` +
          `&perPage=${this.perPage}`,
        config
      );
      this.requests = requests.data;
      this.total = requests.headers["totalrows"];
    },
    LoadReturnedAddressesChart: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const queries = await axios.get(
        `${GlobalConfig.default.GetAPIURL()}/api/stats/requests/addressesreturned?customerId=${this.selectedCompany.CustomerID}&dateFrom=${dateFormat(this.fromDate, "isoDateTime").split("+")[0]}Z` +
          `&dateTo=${dateFormat(this.toDate, "isoDateTime").split("+")[0]}Z`,
        config
      );

      let chartData = { datasets: [], labels: [] };

      const data = [];

      for (const [key, value] of Object.entries(queries.data)) {
        chartData.labels.push(key);
        data.push(value);
      }

      var colour = this.getColor();

      chartData.datasets.push({
        type: "bar",
        label: "Returns",
        backgroundColor: colour,
        fillColor: colour,
        data: data,
      });

      this.returnChartData = chartData;
    },
    getColor: function () {
      const letters = "0123456789ABCDEF";
      let color = "#";

      for (let i = 0; i < 6; i += 1) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    GetCompanies: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const dataReturned = await axios.get(`${GlobalConfig.default.GetAPIURL()}/api/customers`, config);
      this.customers = [{ CustomerID: -1, CustomerName: "All Customers" }];
      this.customers = this.customers.concat(dataReturned.data);
    },
    selectCompany: function () {
      this.selectedCompany = this.customers.find((i) => i.CustomerName === this.selectedCompany);
      this.LoadProviderRequests();
    },
    DropdownChanged(val) {
      if (Object.keys(val.Types).length > 0) this.selectedProviderType = val.Types[Object.keys(val.Types)[0]];
    },
    detailsOpened: async function (row) {
      if (!row.Addresses) {
        this.isDetailLoading = true;
        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ${token}` },
        };
        const requestDetail = await axios.get(`${GlobalConfig.default.GetAPIURL()}/api/stats/requests/${row.ID}`, config);
        row.detailArray = [];
        row.detail = requestDetail.data;

        for (const [key, value] of Object.entries(requestDetail.data)) {
          const obj = { name: key, value: value };
          row.detailArray.push(obj);
        }

        this.isDetailLoading = false;
      }
    },
    onPageChange: async function (page) {
      this.page = page;
      this.isLoading = true;
      await this.LoadRequests();
      this.isLoading = false;
    },
    onSort: async function (field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.isLoading = true;
      await this.LoadRequests();
      this.isLoading = false;
    },
    perPageChanged: async function () {
      await this.LoadRequests();
    },
    LoadProviderReturnsChart: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const returns = await axios.get(
        `${GlobalConfig.default.GetAPIURL()}/api/stats/requests/providersreturns?customerId=${this.selectedCompany.CustomerID}&dateFrom=${dateFormat(this.fromDate, "isoDateTime").split("+")[0]}Z` +
          `&dateTo=${dateFormat(this.toDate, "isoDateTime").split("+")[0]}Z`,
        config
      );

      let chartData = { datasets: [], labels: [] };

      var possibleReturns = [];
      var providers = {};

      let data = {};

      for (let providerRequestsDetail of returns.data) {
        if (providerRequestsDetail.ReturnCount > 3) providerRequestsDetail.ReturnCount = 4;

        if (!possibleReturns.includes(providerRequestsDetail.ReturnCount)) possibleReturns.push(providerRequestsDetail.ReturnCount);
        if (!providers[providerRequestsDetail.ProviderName]) {
          providers[providerRequestsDetail.ProviderName] = {
            ProviderID: providerRequestsDetail.ProviderID,
            ProviderName: providerRequestsDetail.ProviderName,
            ProviderTypes: {},
          };
        }
        if (!providers[providerRequestsDetail.ProviderName].ProviderTypes[providerRequestsDetail.ProviderType]) {
          providers[providerRequestsDetail.ProviderName].ProviderTypes[providerRequestsDetail.ProviderType] = {
            ProviderTypeID: providerRequestsDetail.ProviderTypeID,
            ProviderType: providerRequestsDetail.ProviderType,
          };
        }

        if (data[providerRequestsDetail.ProviderName]) {
          if (data[providerRequestsDetail.ProviderName][providerRequestsDetail.ProviderType]) {
            if (data[providerRequestsDetail.ProviderName][providerRequestsDetail.ProviderType][providerRequestsDetail.ReturnCount]) {
              data[providerRequestsDetail.ProviderName][providerRequestsDetail.ProviderType][providerRequestsDetail.ReturnCount] += providerRequestsDetail.Requests;
            } else {
              data[providerRequestsDetail.ProviderName][providerRequestsDetail.ProviderType][providerRequestsDetail.ReturnCount] = providerRequestsDetail.Requests;
            }
          } else {
            data[providerRequestsDetail.ProviderName][providerRequestsDetail.ProviderType] = {};
            data[providerRequestsDetail.ProviderName][providerRequestsDetail.ProviderType][providerRequestsDetail.ReturnCount] = providerRequestsDetail.Requests;
          }
        } else {
          data[providerRequestsDetail.ProviderName] = {};
          data[providerRequestsDetail.ProviderName][providerRequestsDetail.ProviderType] = {};
          data[providerRequestsDetail.ProviderName][providerRequestsDetail.ProviderType][providerRequestsDetail.ReturnCount] = providerRequestsDetail.Requests;
        }
      }

      for (const [providerName] of Object.entries(data)) {
        for (const [ProviderType] of Object.entries(data[providerName])) {
          const label = providerName + " - " + ProviderType;
          chartData.labels.push(label);
        }
      }

      possibleReturns.sort((a, b) => a - b);

      for (let possibleReturn of possibleReturns) {
        var datasetData = [];

        for (let providerKey in providers) {
          const provider = providers[providerKey];
          for (let providerTypeKey in provider.ProviderTypes) {
            const providerType = provider.ProviderTypes[providerTypeKey];
            if (data[provider.ProviderName] && data[provider.ProviderName][providerType.ProviderType] && data[provider.ProviderName][providerType.ProviderType][possibleReturn]) {
              datasetData.push(data[provider.ProviderName][providerType.ProviderType][possibleReturn]);
            } else {
              datasetData.push(0);
            }
          }
        }

        var colour = "#FF0000";
        if (possibleReturn !== 0) {
          colour = this.getColor();
        }

        let returnsString = possibleReturn + " addresses returned for ";
        if (possibleReturn == 4) returnsString = "4+ returned";

        chartData.datasets.push({
          type: "bar",
          label: returnsString,
          backgroundColor: colour,
          fillColor: colour,
          data: datasetData,
        });
      }

      this.overallChartData = chartData;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
